// deps
import React, { memo, ReactElement, useCallback, useState } from "react";

//components
import { default as TickScreenV4 } from "./v4/TickScreen";
import { default as TickScreenV5 } from "./v5/TransitionScreen";

//interfaces
import { OnTransitionError, TickScreenProps } from "./interfaces";

//helpers
import { isEmpty } from "@swiggy-private/js-utils";

function TickScreen(props: TickScreenProps): ReactElement {
    const { onTransitionScreenError, transitionScreenEnabled } = props;
    const [errorFallback, setErrorFallback] = useState<boolean>(false);
    const showTickScreenV5 = props.isRegular || props.isGiftingCart;

    const onTransitionError = useCallback<OnTransitionError>(
        (errorType, error, url) => {
            setErrorFallback(true);
            onTransitionScreenError?.(errorType, error, url);
        },
        [onTransitionScreenError],
    );

    if (showTickScreenV5 && !isEmpty(props.deliveryAddress) && !errorFallback && !isEmpty(transitionScreenEnabled)) {
        return <TickScreenV5 {...props} onError={onTransitionError} />;
    }
    return <TickScreenV4 {...props} />;
}

export default memo(TickScreen);
